import script from "./TextSectionWithCta.vue?vue&type=script&setup=true&lang=js"
export * from "./TextSectionWithCta.vue?vue&type=script&setup=true&lang=js"

import "./TextSectionWithCta.vue?vue&type=style&index=0&id=705b9918&lang=scss&scoped=true"

import exportComponent from "/Users/matteo.direnzo/Documents/TVA/eni-digit_eni-storia/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-705b9918"]])

export default __exports__